import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from 'react-native';
import { Row, PrimaryButton } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { fontSizes, metrics, pixelScaler } from 'src/themes/Metrics';
import styled from 'styled-components/native';

interface Props {
  onApplyPress(coupon: string): any;
}

const Styled = {
  Wrapper: styled.View`
    flex: 1;
    border-top-left-radius: ${metrics.borderRadius}px;
    border-bottom-left-radius: ${metrics.borderRadius}px;
    height: ${pixelScaler(50)}px;
    border-width: 1px;
    border-color: ${AppColors.gray};
    border-style: dashed;
  `,
};

export const ApplyCouponCode = ({ onApplyPress }: Props) => {
  const [coupon, setCoupon] = React.useState<string>('');
  const { t } = useTranslation();

  return (
    <Row width="100%">
      <Styled.Wrapper>
        <TextInput
          value={coupon}
          onChangeText={setCoupon}
          placeholder={t('applyCouponCode')}
          placeholderTextColor={AppColors.gray}
          style={[
            { fontSize: fontSizes.large, flex: 1, paddingHorizontal: metrics.medium },
            {
              outlineWidth: 0,
            } as any,
          ]}
        />
      </Styled.Wrapper>
      <PrimaryButton
        height={pixelScaler(50)}
        text="apply"
        onPress={() => onApplyPress(coupon)}
        style={{
          width: 100,
          borderRadius: 0,
          borderTopRightRadius: metrics.borderRadius,
          borderBottomRightRadius: metrics.borderRadius,
        }}
      />
    </Row>
  );
};
